<template>
    <div
        :id="`jevy-${item.KOD}`"
        class="group grid border-t border-black-text py-6 first-of-type:border-t-0"
        :style="contentExpandedStyles"
    >
        <span
            class="flex cursor-pointer items-start gap-3 font-proregular text-xl hover:text-hover-link"
            @click="expanded = !expanded"
        >
            <div class="relative top-1 flex items-center gap-2 md:top-0.5">
                <i
                    class="pi cursor-pointer"
                    :class="{
                        'pi-angle-right': !expanded,
                        'pi-angle-down': expanded,
                    }"
                />
                <TagItem
                    :item="item.KOD"
                    type="jevy"
                    class="pointer-events-none"
                />
            </div>
            <div class="">
                <span>{{ item.NAZEV }}</span>
                <div v-if="store.mobileMode">
                    <span
                        v-if="item.KOD20"
                        class="ml-auto shrink-0 text-base text-weak"
                        >(dříve {{ item.KOD20?.replaceAll(",", ", ") }})</span
                    >
                    <span
                        v-else
                        class="ml-auto shrink-0 text-base text-weak"
                        >(dříve nesledováno)</span
                    >
                </div>
            </div>
            <template v-if="!store.mobileMode">
                <span
                    v-if="item.KOD20"
                    class="ml-auto shrink-0 text-base text-weak"
                    >(dříve {{ item.KOD20?.replaceAll(",", ", ") }})</span
                >
                <span
                    v-else
                    class="ml-auto shrink-0 text-base text-weak"
                    >(dříve nesledováno)</span
                >
            </template>
        </span>
        <div
            class="overflow-hidden bg-white duration-200"
            :class="{
                'opacity-0': !expanded,
            }"
        >
            <KjevJevDetail
                v-if="mounted && !store.mobileMode"
                :item
                :type
            />
            <KjevJevDetailMobile
                v-else-if="mounted && store.mobileMode"
                :item
                :type
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
const store = useMainStore()

const props = defineProps<{
    item: JevItemProcessed
    open: boolean
    type: "O" | "K"
}>()

const expanded = ref(props.open)
const contentExpandedStyles = computed(() => {
    if (expanded.value) {
        return {
            gridTemplateRows: "min-content 1fr",
            transition: "grid-template-rows 0.2s",
        }
    } else {
        return {
            gridTemplateRows: "min-content 0fr",
            transition: "grid-template-rows 0.2s",
        }
    }
})

const mounted = ref(props.open)
watch(expanded, () => {
    if (expanded.value) {
        mounted.value = true
    } else
        setTimeout(() => {
            mounted.value = false
        }, 200)
})
</script>

<style scoped></style>
